import React, { FC } from "react"
import ReactMarkdown from "react-markdown"
import { Card } from "antd"
import css from "./AGB.module.css"

const AGB: FC = () => {
    const content = `# Allgemeine Geschäftsbedingungen

## Nutzungsbedingungen

## 1. Geltungsbereich

Diese Nutzungsbedingungen gelten für die Nutzung des Online-Buchungsportals für Kurse, das durch die KursOrganizer GmbH als technischer Dienstleister betrieben wird.

Sie regeln ausschließlich die technische Nutzung der Plattform.

Die Regelungen über Kursinhalte, Teilnahmebedingungen, Stornierungen, Zahlungen oder sonstige Vertragsbestandteile zwischen Kursteilnehmern und Schwimmschulen sind nicht Gegenstand dieser Bedingungen.

---

## 2. Rolle der KursOrganizer GmbH

Die KursOrganizer GmbH stellt lediglich die technische Plattform zur Verfügung, über die Kursteilnehmer Kurse bei eigenständigen Anbietern (z. B. Schwimmschulen) buchen können.

Ein Vertragsverhältnis über den Kurs kommt ausschließlich zwischen dem Kursanbieter und dem Endkunden zustande.

Die KursOrganizer GmbH ist nicht:

- Anbieter der Kurse
- Vertragspartner der Kursteilnehmer
- verantwortlich für Inhalte, Preise, Organisation oder Durchführung der Kurse

---

## 3. Nutzung der Plattform

(1) Die Nutzung erfolgt über einen aktuellen Internetbrowser.

(2) Die Nutzer verpflichten sich, alle Angaben vollständig und wahrheitsgemäß zu machen.

(3) Zugangsdaten dürfen nicht an Dritte weitergegeben werden.

(4) Manipulationen, automatisierte Zugriffe oder sicherheitsgefährdende Aktivitäten sind unzulässig.

---

## 4. Datenverarbeitung

(1) Die eingegebenen Daten werden ausschließlich zur Kursbuchung und Kundenverwaltung verarbeitet.

(2) Verantwortlich für die Datenverarbeitung ist die jeweilige Schwimmschule.

Die KursOrganizer GmbH verarbeitet personenbezogene Daten im Auftrag nach Art. 28 DSGVO ("Auftragsverarbeiter").

(3) Weitere Informationen ergeben sich aus der Datenschutzerklärung des jeweiligen Kursanbieters.

---

## 5. Verfügbarkeit und technische Änderungen

(1) Die Plattform ist im Jahresdurchschnitt zu 95 % verfügbar. Kurzzeitige Unterbrechungen durch Wartung, Updates oder technische Störungen sind möglich.

(2) Updates und Weiterentwicklungen können jederzeit vorgenommen werden.

(3) Es besteht kein Anspruch auf jederzeitige, unterbrechungsfreie Verfügbarkeit der Plattform.

---

## 6. Technische Störungen und Support

(1) Störungen können über die in der Plattform angegebenen Kontaktmöglichkeiten gemeldet werden.

(2) Die KursOrganizer GmbH übernimmt keine Verantwortung für Ausfälle, die außerhalb ihres Einflussbereichs liegen (z. B. Internetstörungen, Hosting-Ausfälle, höhere Gewalt).

(3) Im Fall technischer Einschränkungen besteht kein Anspruch auf Schadensersatz oder Preisreduktion gegenüber der KursOrganizer GmbH.

---

## 7. Pflichten der Nutzer

Die Nutzer verpflichten sich:

- die Plattform nur im gesetzlichen Rahmen zu nutzen
- keine rechtswidrigen oder schadhaften Inhalte einzugeben
- Systeme der Plattform nicht zu beeinträchtigen oder zu überlasten

---

## 8. Haftung

(1) Die KursOrganizer GmbH haftet nur für Vorsatz und grobe Fahrlässigkeit.

(2) Bei leicht fahrlässigen Pflichtverletzungen ist die Haftung auf vorhersehbare Schäden bis max. 50.000 € begrenzt (analog zum SaaS-Vertrag mit den Schwimmschulen).

(3) Die KursOrganizer GmbH haftet nicht für:

- Kursdurchführung
- Kursinhalte
- Preise, Stornos, Rückerstattungen
- organisatorische oder vertragliche Themen zwischen Nutzer und Kursanbieter
- Fehlerhafte oder unvollständige Angaben der Nutzer oder Kursanbieter

(4) Die gesetzliche Haftung für Schäden an Leben, Körper oder Gesundheit bleibt unberührt.

---

## 9. Schlussbestimmungen

(1) Es gilt deutsches Recht.

(2) Sollte eine Bestimmung unwirksam sein, bleibt der Rest der Bedingungen wirksam.

(3) Änderungen dieser Bedingungen werden online veröffentlicht und gelten mit Veröffentlichung.`

    return (
        <div className={css.container}>
            <Card className={css.card}>
                <div className={css.content}>
                    <ReactMarkdown>{content}</ReactMarkdown>
                </div>
            </Card>
        </div>
    )
}

export default AGB

